"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminLegacyInformation = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const AdminMGTProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/AdminMGTProvider");
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const antd_1 = require("antd");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const PageLoaderComponent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/common/pageLoader/PageLoaderComponent"));
const AdminLegacyInformation = () => {
    var _a;
    const isMounted = (0, isMounted_1.default)();
    const adminMGTContext = (0, AdminMGTProvider_1.useAdminMGTContext)();
    const inProgress = adminMGTContext.status.inProgress;
    const matchAdmin = (0, react_router_dom_1.useRouteMatch)(AppRouting_1.PATH__ADMIN__LEGACY + "/:metricsName");
    console.log("AdminLegacyInformation", matchAdmin);
    let metricsName = undefined;
    if (matchAdmin) {
        metricsName = matchAdmin.params.metricsName;
    }
    (0, react_1.useEffect)(() => {
        if (isMounted()) {
            (async () => {
                console.log("metricsName", metricsName);
                await adminMGTContext.getInformation(metricsName);
            })();
        }
    }, [isMounted, metricsName]);
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.PageHeader, { title: "Usergeek Admin: legacy info: " + metricsName }),
        React.createElement(PageContent_1.default, null,
            React.createElement(PageContent_1.default.Card, null, inProgress ? React.createElement(PageLoaderComponent_1.default, null)
                :
                    (_a = adminMGTContext.data) === null || _a === void 0 ? void 0 : _a.fallback)));
};
exports.AdminLegacyInformation = AdminLegacyInformation;
